import { css, styled } from 'css-literal-loader/styled';
import React from 'react';
import withProps from 'recompose/withProps';
import Layout from '@4c/layout';

import Card from './Card';
import Form from './Form';

export const InterstitialHeader = styled('header', null, "InterstitialHeader", require("./Interstitial-InterstitialHeader.module.scss"), "interstitial-header", "interstitialHeader");

export const InterstitialForm = withProps({
  pad: 5,
  direction: 'column',
  as: Form,
})(
  styled(Layout, null, "InterstitialForm", require("./Interstitial-InterstitialForm.module.scss"), "interstitial-form", "interstitialForm"),
);

const styles = require('./Interstitial-styles.module.scss');

export default function Interstitial({ children }) {
  return (
    <Layout className={styles.container} justify="center" aria-modal="true">
      <Card className={styles.card}>{children}</Card>
    </Layout>
  );
}
